// src/pages/ServicesPage.jsx
import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  useTheme
} from '@mui/material';
import { motion } from 'framer-motion';
import {
  FaLaptopCode,
  FaMobileAlt,
  FaPalette,
  FaShoppingCart,
  FaRobot,
  FaServer,
  FaBullhorn
} from 'react-icons/fa';
// import Navbar from '../components/Navbar';
// import Footer from '../components/Footer';
import SocialMediaPackages from '../components/SocialMediaPackages';
import ServicesSection from '../components/ServicesSection';

const services = [
  {
    title: 'Web & Mobile Development',
    icon: FaLaptopCode,
    desc:
      'High-performance websites and cross-platform mobile apps using React, Next.js, React Native & Expo.'
  },
  {
    title: 'UI/UX Design',
    icon: FaPalette,
    desc:
      'User-first interfaces, wireframes & prototypes crafted in Figma and Adobe XD to delight your customers.'
  },
  {
    title: 'E-commerce Solutions',
    icon: FaShoppingCart,
    desc:
      'End-to-end online stores (Shopify, WooCommerce, custom) with smooth checkout and payment integrations.'
  },
  {
    title: 'AI Integration',
    icon: FaRobot,
    desc:
      'Custom GPT-powered chatbots, recommendation engines and analytics pipelines to supercharge your product.'
  },
  {
    title: 'DevOps & Cloud',
    icon: FaServer,
    desc:
      'Docker, Kubernetes, CI/CD, and AWS/GCP/OCI best practices for rock-solid, scalable infrastructure.'
  },
  {
    title: 'Digital Marketing',
    icon: FaBullhorn,
    desc:
      'SEO, social media campaigns, paid ads & content strategy—all data-driven to grow your brand.'
  },
  {
    title: 'Mobile-First Experiences',
    icon: FaMobileAlt,
    desc:
      'Progressive Web Apps (PWA) and responsive designs that look and feel native on any device.'
  },
  {
    title: 'Maintenance & Support',
    icon: FaServer,
    desc:
      '24/7 monitoring, backups, security audits and on-demand feature updates to keep you moving.'
  },
];

export default function ServicesPage() {
  const theme = useTheme();

  return (
  <>
  {/* <Navbar/> */}
    <Box
      component="section"
      sx={{
        py: { xs: 6, md: 12 },
        background: theme.palette.background.default
      }}
    >

      <ServicesSection/>
      <SocialMediaPackages/>
    </Box>
    {/* <Footer/> */}
    </>
  );
}
